import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";
import type { IPurchaseInvoicesReturnItemsResponse } from "@api/stores/purchaseInvoices/returns/items/types";

import type { IPathBaseParam, IPathByIdParam } from "./path";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IPurchaseInvoicesReturnItemsResponse>>,
  IPathBaseParam,
  IPaginationParams
>("stores.purchaseInvoices.returns.items");
const getApis = createGetApi<
  IApiResponse<IPurchaseInvoicesReturnItemsResponse>,
  IPathByIdParam,
  object
>("stores.purchaseInvoices.returns.items");

export const items = {
  ...getAllApis,
  ...getApis,
};
